// extracted by mini-css-extract-plugin
module.exports = {"container":"proxy-module_container_2qNo7"};